import React, { type JSX } from 'react'
import { ThemeProvider } from '@emotion/react'
import { PasswordThemes, getPasswordTheme } from '../../Password/themes'
import {
  PasswordFormStyled,
  PasswordGroupStyled,
  PasswordInputStyled,
  PasswordLabelStyled,
} from '../Password.styles'
import { PasswordVisibilityToggle } from './VisibilityToggle'

export interface PasswordComponent {
  labelName: string
  themeName?: PasswordThemes
  onChange: (event: React.FormEvent<HTMLInputElement>) => void | null
  onBlur?: (event: React.FormEvent<HTMLInputElement>) => void | null
  onVisibleToggle: () => void
  isPasswordVisible: boolean
  validationError: false | string
  testId?: string
}

export const PasswordComponent = ({
  labelName,
  themeName,
  onChange,
  onBlur,
  onVisibleToggle,
  isPasswordVisible,
  validationError,
  testId,
}: PasswordComponent): JSX.Element => {
  const labelRef = React.useRef<HTMLLabelElement>(null)
  const theme = getPasswordTheme(themeName)
  const onChangePassword = (event: React.FormEvent<HTMLInputElement>) => {
    onChange(event)
  }

  return (
    <ThemeProvider theme={theme}>
      <PasswordFormStyled>
        <PasswordLabelStyled htmlFor={labelName} ref={labelRef}>
          {labelName || 'Password*'}
        </PasswordLabelStyled>
        <PasswordGroupStyled>
          <PasswordInputStyled
            id={labelName}
            onChange={onChangePassword}
            onBlur={onBlur}
            type={isPasswordVisible ? 'text' : 'password'}
            errorMessage={validationError}
            testId={testId}
          />
          <PasswordVisibilityToggle
            isPasswordVisible={isPasswordVisible}
            onClick={onVisibleToggle}
            themeName={themeName}
          />
        </PasswordGroupStyled>
      </PasswordFormStyled>
    </ThemeProvider>
  )
}
